import React from 'react';
import { FiUser, FiFileText } from 'react-icons/fi';
import { useRequester } from '../../context/RequesterContext';

const CERTIFICATIONS = [
  'SOC 2 Type II', 'ISO 27001', 'GDPR Compliant',
  'HIPAA Ready', '99.9% Uptime SLA', 'End-to-end Encrypted',
];

const RequesterHero = () => {
  const { openRequestModal } = useRequester();

  return (
    <section className="bg-[ #ffffff] text-white py-[2.25rem]">
      <div className="max-w-screen-2xl mx-auto px-[7rem]">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">

          {/* Left Content */}
          <div>
            <div className="inline-flex items-center gap-2 bg-[#ff6600]/10 border border-[#ff6600]/30 text-[#ff6600] px-3 py-1 rounded-full text-xs font-semibold mb-6">
              <span className="w-2 h-2 rounded-full bg-[#ff6600]"></span>
              VERIFIED TRUST CENTER
            </div>
            <h1 className="text-4xl font-bold leading-tight mb-3 text-[#171a1f]">
              The AI-Powered Proof<br />Your Customers Can Trust.
            </h1>
            <p className="text-2xl font-bold text-[#ff6600] mb-2">
              Instant Answers. Ironclad Trust.
            </p>
            <p className="text-lg font-bold text-[#0077b5] mb-5">
              80% Less Effort. 50% Reduced Cost. 100% Compliance.
            </p>
            <p className="text-[#5e6060] text-base mb-8 leading-relaxed">
              <span className="font-bold text-[#171a1f]">MyRiskShield's</span> automated
              Trust Center uses AI to instantly respond to complex risk assessments
              and security reviews. Build ironclad trust with your customers and their
              compliance teams while cutting your risk assessment efforts and review
              cycles by 80%.
            </p>
            <div className="flex flex-wrap gap-3 mb-8">
              <button
                onClick={openRequestModal}
                className="bg-[#ff6600] text-white px-6 py-2.5 text-sm hover:bg-[#0077b5]/80 font-semibold transition-colors"
              >
                Send a request
              </button>
              <button
                onClick={() => window.open('https://outlook.office365.com/owa/calendar/ITPeopleNetworkRiskAssessmentSupport@itpeoplenetwork.com/bookings/', '_blank')}
                className="border border-[#919191]/50 text-[#5e6060] px-6 py-2.5 text-sm  hover:bg-white/5 transition-colors"
              >
                Schedule a demo
              </button>
            </div>
            <div className="flex flex-wrap gap-x-5 gap-y-1.5 text-xs text-[#919191]">
              {CERTIFICATIONS.map((cert) => (
                <span key={cert} className="flex items-center gap-1.5">
                  <span className="w-2 h-2 rounded-full bg-[#ff6600] flex-shrink-0"></span>
                  {cert}
                </span>
              ))}
            </div>
          </div>

          {/* Right - Trust Flow Model Image */}
          <div className="flex justify-center lg:justify-end">
            <img
              src="/trust-center/TrustCenterFlow.png"
              alt="Trust Center Flow Model"
              className="w-full max-w-xl"
            />
          </div>

        </div>
      </div>
    </section>
  );
};

export default RequesterHero;
